import React from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import { OneWayInServiceDto } from 'src/api/v2';

const columnHelper = createColumnHelper<OneWayInServiceDto>();

export const serviceColumns = [
  columnHelper.accessor((row) => row.name, {
    id: 'serviceName',
    cell: (info) => {
      return <span>{info.getValue()}</span>;
    },
  }),
  columnHelper.accessor((row) => row.businessName, {
    id: 'actor',
    cell: (info) => {
      return <span>{info.getValue()}</span>;
    },
  }),
  columnHelper.accessor((row) => row.contactName, {
    id: 'contactPerson',
    cell: (info) => {
      return <span>{info.getValue()}</span>;
    },
  }),
];
